exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Montserrat', sans-serif; }\n  body .pt-page-moveToBottom {\n    -webkit-animation: moveToBottom .6s ease both;\n    animation: moveToBottom .6s ease both;\n    animation-delay: .2s; }\n  body .pt-page-scaleUp {\n    -webkit-animation: scaleUp .7s ease both;\n    animation: scaleUp .7s ease both;\n    animation-delay: .2s; }\n  body .pt-ab {\n    position: absolute;\n    width: 100%; }\n\n@-webkit-keyframes moveToBottom {\n  from { }\n  to {\n    -webkit-transform: translateY(100%); } }\n\n@keyframes moveToBottom {\n  from { }\n  to {\n    -webkit-transform: translateY(100%);\n    transform: translateY(100%); } }\n\n@-webkit-keyframes scaleUp {\n  from {\n    opacity: 0;\n    -webkit-transform: scale(0.8); } }\n\n@keyframes scaleUp {\n  from {\n    opacity: 0;\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8); } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Transition/index.scss
// module id = 1094
// module chunks = 0